var map = {
	"./casino-bg.embed.svg": 260875,
	"./casino-cs.embed.svg": 260978,
	"./casino-da.embed.svg": 338829,
	"./casino-de.embed.svg": 342577,
	"./casino-el.embed.svg": 155355,
	"./casino-en.embed.svg": 958989,
	"./casino-es.embed.svg": 82724,
	"./casino-et.embed.svg": 758343,
	"./casino-fi.embed.svg": 817701,
	"./casino-fr.embed.svg": 353694,
	"./casino-hr.embed.svg": 519730,
	"./casino-hu.embed.svg": 825574,
	"./casino-is.embed.svg": 155119,
	"./casino-it.embed.svg": 85510,
	"./casino-ja.embed.svg": 51066,
	"./casino-lt.embed.svg": 903007,
	"./casino-lv.embed.svg": 647794,
	"./casino-nl.embed.svg": 613403,
	"./casino-no.embed.svg": 27898,
	"./casino-pl.embed.svg": 397271,
	"./casino-pt-BR.embed.svg": 50516,
	"./casino-pt.embed.svg": 995850,
	"./casino-ro.embed.svg": 927797,
	"./casino-ru.embed.svg": 732575,
	"./casino-sl.embed.svg": 362515,
	"./casino-sv.embed.svg": 577863,
	"./casino-uk.embed.svg": 774036,
	"./casino-zh-CN.embed.svg": 424167,
	"./casino-zh-TW.embed.svg": 750745,
	"./poker-bg.embed.svg": 577638,
	"./poker-ca.embed.svg": 416730,
	"./poker-cs.embed.svg": 608824,
	"./poker-da.embed.svg": 180792,
	"./poker-de.embed.svg": 457160,
	"./poker-el.embed.svg": 757965,
	"./poker-en.embed.svg": 736947,
	"./poker-es.embed.svg": 185787,
	"./poker-et.embed.svg": 703409,
	"./poker-fi.embed.svg": 111405,
	"./poker-fr.embed.svg": 622460,
	"./poker-hr.embed.svg": 728839,
	"./poker-hu.embed.svg": 967364,
	"./poker-is.embed.svg": 416998,
	"./poker-it.embed.svg": 391082,
	"./poker-ja.embed.svg": 638999,
	"./poker-lt.embed.svg": 656466,
	"./poker-lv.embed.svg": 488759,
	"./poker-nl.embed.svg": 141566,
	"./poker-no.embed.svg": 371715,
	"./poker-pl.embed.svg": 788705,
	"./poker-pt-BR.embed.svg": 849538,
	"./poker-pt.embed.svg": 876909,
	"./poker-ro.embed.svg": 565425,
	"./poker-ru.embed.svg": 890282,
	"./poker-sl.embed.svg": 64826,
	"./poker-sv.embed.svg": 394919,
	"./poker-uk.embed.svg": 506517,
	"./poker-zh-CN.embed.svg": 643669,
	"./poker-zh-TW.embed.svg": 115207,
	"./sports-bg.embed.svg": 16580,
	"./sports-ca.embed.svg": 101699,
	"./sports-cs.embed.svg": 997895,
	"./sports-da.embed.svg": 310230,
	"./sports-de.embed.svg": 519032,
	"./sports-el.embed.svg": 464917,
	"./sports-en.embed.svg": 667664,
	"./sports-es.embed.svg": 76127,
	"./sports-et.embed.svg": 243003,
	"./sports-fi.embed.svg": 401782,
	"./sports-fr.embed.svg": 612572,
	"./sports-hr.embed.svg": 713800,
	"./sports-hu.embed.svg": 17638,
	"./sports-is.embed.svg": 204249,
	"./sports-it.embed.svg": 372434,
	"./sports-ja.embed.svg": 874171,
	"./sports-lt.embed.svg": 533416,
	"./sports-lv.embed.svg": 406311,
	"./sports-nl.embed.svg": 38168,
	"./sports-no.embed.svg": 454397,
	"./sports-pl.embed.svg": 850329,
	"./sports-pt-BR.embed.svg": 501260,
	"./sports-pt.embed.svg": 311529,
	"./sports-ro.embed.svg": 19483,
	"./sports-ru.embed.svg": 924339,
	"./sports-sl.embed.svg": 5419,
	"./sports-sv.embed.svg": 989479,
	"./sports-uk.embed.svg": 511765,
	"./sports-zh-CN.embed.svg": 718583,
	"./sports-zh-TW.embed.svg": 697901,
	"swf-core/assets/localized/casino-bg.embed.svg": 260875,
	"swf-core/assets/localized/casino-cs.embed.svg": 260978,
	"swf-core/assets/localized/casino-da.embed.svg": 338829,
	"swf-core/assets/localized/casino-de.embed.svg": 342577,
	"swf-core/assets/localized/casino-el.embed.svg": 155355,
	"swf-core/assets/localized/casino-en.embed.svg": 958989,
	"swf-core/assets/localized/casino-es.embed.svg": 82724,
	"swf-core/assets/localized/casino-et.embed.svg": 758343,
	"swf-core/assets/localized/casino-fi.embed.svg": 817701,
	"swf-core/assets/localized/casino-fr.embed.svg": 353694,
	"swf-core/assets/localized/casino-hr.embed.svg": 519730,
	"swf-core/assets/localized/casino-hu.embed.svg": 825574,
	"swf-core/assets/localized/casino-is.embed.svg": 155119,
	"swf-core/assets/localized/casino-it.embed.svg": 85510,
	"swf-core/assets/localized/casino-ja.embed.svg": 51066,
	"swf-core/assets/localized/casino-lt.embed.svg": 903007,
	"swf-core/assets/localized/casino-lv.embed.svg": 647794,
	"swf-core/assets/localized/casino-nl.embed.svg": 613403,
	"swf-core/assets/localized/casino-no.embed.svg": 27898,
	"swf-core/assets/localized/casino-pl.embed.svg": 397271,
	"swf-core/assets/localized/casino-pt-BR.embed.svg": 50516,
	"swf-core/assets/localized/casino-pt.embed.svg": 995850,
	"swf-core/assets/localized/casino-ro.embed.svg": 927797,
	"swf-core/assets/localized/casino-ru.embed.svg": 732575,
	"swf-core/assets/localized/casino-sl.embed.svg": 362515,
	"swf-core/assets/localized/casino-sv.embed.svg": 577863,
	"swf-core/assets/localized/casino-uk.embed.svg": 774036,
	"swf-core/assets/localized/casino-zh-CN.embed.svg": 424167,
	"swf-core/assets/localized/casino-zh-TW.embed.svg": 750745,
	"swf-core/assets/localized/poker-bg.embed.svg": 577638,
	"swf-core/assets/localized/poker-ca.embed.svg": 416730,
	"swf-core/assets/localized/poker-cs.embed.svg": 608824,
	"swf-core/assets/localized/poker-da.embed.svg": 180792,
	"swf-core/assets/localized/poker-de.embed.svg": 457160,
	"swf-core/assets/localized/poker-el.embed.svg": 757965,
	"swf-core/assets/localized/poker-en.embed.svg": 736947,
	"swf-core/assets/localized/poker-es.embed.svg": 185787,
	"swf-core/assets/localized/poker-et.embed.svg": 703409,
	"swf-core/assets/localized/poker-fi.embed.svg": 111405,
	"swf-core/assets/localized/poker-fr.embed.svg": 622460,
	"swf-core/assets/localized/poker-hr.embed.svg": 728839,
	"swf-core/assets/localized/poker-hu.embed.svg": 967364,
	"swf-core/assets/localized/poker-is.embed.svg": 416998,
	"swf-core/assets/localized/poker-it.embed.svg": 391082,
	"swf-core/assets/localized/poker-ja.embed.svg": 638999,
	"swf-core/assets/localized/poker-lt.embed.svg": 656466,
	"swf-core/assets/localized/poker-lv.embed.svg": 488759,
	"swf-core/assets/localized/poker-nl.embed.svg": 141566,
	"swf-core/assets/localized/poker-no.embed.svg": 371715,
	"swf-core/assets/localized/poker-pl.embed.svg": 788705,
	"swf-core/assets/localized/poker-pt-BR.embed.svg": 849538,
	"swf-core/assets/localized/poker-pt.embed.svg": 876909,
	"swf-core/assets/localized/poker-ro.embed.svg": 565425,
	"swf-core/assets/localized/poker-ru.embed.svg": 890282,
	"swf-core/assets/localized/poker-sl.embed.svg": 64826,
	"swf-core/assets/localized/poker-sv.embed.svg": 394919,
	"swf-core/assets/localized/poker-uk.embed.svg": 506517,
	"swf-core/assets/localized/poker-zh-CN.embed.svg": 643669,
	"swf-core/assets/localized/poker-zh-TW.embed.svg": 115207,
	"swf-core/assets/localized/sports-bg.embed.svg": 16580,
	"swf-core/assets/localized/sports-ca.embed.svg": 101699,
	"swf-core/assets/localized/sports-cs.embed.svg": 997895,
	"swf-core/assets/localized/sports-da.embed.svg": 310230,
	"swf-core/assets/localized/sports-de.embed.svg": 519032,
	"swf-core/assets/localized/sports-el.embed.svg": 464917,
	"swf-core/assets/localized/sports-en.embed.svg": 667664,
	"swf-core/assets/localized/sports-es.embed.svg": 76127,
	"swf-core/assets/localized/sports-et.embed.svg": 243003,
	"swf-core/assets/localized/sports-fi.embed.svg": 401782,
	"swf-core/assets/localized/sports-fr.embed.svg": 612572,
	"swf-core/assets/localized/sports-hr.embed.svg": 713800,
	"swf-core/assets/localized/sports-hu.embed.svg": 17638,
	"swf-core/assets/localized/sports-is.embed.svg": 204249,
	"swf-core/assets/localized/sports-it.embed.svg": 372434,
	"swf-core/assets/localized/sports-ja.embed.svg": 874171,
	"swf-core/assets/localized/sports-lt.embed.svg": 533416,
	"swf-core/assets/localized/sports-lv.embed.svg": 406311,
	"swf-core/assets/localized/sports-nl.embed.svg": 38168,
	"swf-core/assets/localized/sports-no.embed.svg": 454397,
	"swf-core/assets/localized/sports-pl.embed.svg": 850329,
	"swf-core/assets/localized/sports-pt-BR.embed.svg": 501260,
	"swf-core/assets/localized/sports-pt.embed.svg": 311529,
	"swf-core/assets/localized/sports-ro.embed.svg": 19483,
	"swf-core/assets/localized/sports-ru.embed.svg": 924339,
	"swf-core/assets/localized/sports-sl.embed.svg": 5419,
	"swf-core/assets/localized/sports-sv.embed.svg": 989479,
	"swf-core/assets/localized/sports-uk.embed.svg": 511765,
	"swf-core/assets/localized/sports-zh-CN.embed.svg": 718583,
	"swf-core/assets/localized/sports-zh-TW.embed.svg": 697901
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(__webpack_require__);
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 272090;
module.exports = webpackAsyncContext;